import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { Message as MessageIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

interface MessageButtonProps extends Omit<ButtonProps, 'onClick'> {
  userId: string;
  userName?: string;
  contextType?: 'ride' | 'request' | 'bid';
  contextId?: string;
  label?: string;
}

const MessageButton: React.FC<MessageButtonProps> = ({
  userId,
  userName,
  contextType,
  contextId,
  label = 'Send Message',
  ...buttonProps
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/inbox/${userId}`, {
      state: {
        contextType,
        contextId,
        partnerName: userName
      }
    });
  };

  return (
    <Button
      variant="outlined"
      color="primary"
      startIcon={<MessageIcon />}
      onClick={handleClick}
      {...buttonProps}
    >
      {label}
    </Button>
  );
};

export default MessageButton;

